import { useTranslation } from "@repo/shared/i18n";

import { Squad } from "../../../../../redux/squadBuilder/squadBuilderUtils";
import { MetaRatingAndChemistry } from "../../../../molecules/MetaRatingAndChemistry/MetaRatingAndChemistry";
import ChemSummary from "../../../../organisms/SquadBuilder/ChemSummary/ChemSummary";
import { PanelHeader } from "../../RightPanel/PanelHeader/PanelHeader";
import { ComponentContainer } from "../../components/ComponentContainer/ComponentContainer";
import { PanelContainer } from "../../components/PanelContainer/PanelContainer";
import { SquadPrice } from "./SquadPrice/SquadPrice";

type Props = {
  squad: Squad;
  tempSquad: Squad;
};
export const ChemistryOverviewMode = ({ squad, tempSquad }: Props) => {
  const { t } = useTranslation("squadBuilder");
  const {
    manager: tempManager,
    players: tempPlayers,
    chemistry: tempChemistry,
    metaRating: tempMetaRating,
  } = tempSquad;

  const { chemistry, metaRating, players } = squad;
  const showChemSummary =
    players.find((p) => p?.resourceId) ||
    tempPlayers.find((p) => p?.resourceId) ||
    squad.manager.country ||
    squad.manager.league;

  const overview = (
    <>
      <ComponentContainer marginTop="mt-8">
        <MetaRatingAndChemistry
          tempPlayers={tempPlayers}
          tempManager={tempManager}
          chemistry={chemistry}
          metaRating={metaRating}
          tempChemistry={tempChemistry}
          tempMetaRating={tempMetaRating}
        />
      </ComponentContainer>

      <SquadPrice tempSquad={tempSquad} />
      {!!showChemSummary && (
        <ChemSummary
          currentSummary={
            tempMetaRating ? tempChemistry.summary : chemistry.summary
          }
          previousSummary={chemistry.summary}
          playersOutOfPosition={
            tempMetaRating
              ? tempChemistry.playersOutOfPosition
              : chemistry.playersOutOfPosition
          }
        />
      )}
    </>
  );

  return (
    <>
      <PanelHeader title={t("panel.squadOverview")} />
      <PanelContainer>{overview}</PanelContainer>
    </>
  );
};
